import Vue from 'vue'
import routing from '@/util/routes'
import Router from '@/router'

const reset = {
  token: null,
  user: {}
}

export default {
  state: {
    token: null,
    user: {}
  },
  mutations: {
    setToken: (state, payload) => {
      state.token = payload
    },
    setUser: (state, payload) => {
      state.user = payload
    },
    resetData: (state) => {
      Object.keys(reset).forEach(key => { state[key] = reset[key] })
    }
  },
  actions: {
    async getUserAtual ({ commit }) {
      const response = await Vue.axios.get(`${routing}/user`)
      commit('setUser', response.data.user)
      return response
    },
    async login ({ commit }, payload) {
      const response = await Vue.axios.post(
        `${routing}`,
        payload
      )
      commit('setToken', response.data.token)
      commit('setUser', response.data.user)
      return response
    },
    signout ({ commit }, payload) {
      commit('resetData')
      return Router.push({
        name: 'login'
      })
    }
  },
  getters: {
    token: ({ token }) => token,
    isLogged: ({ token }) => !!token,
    user: ({ user }) => user,
    role: ({ user }) => user.role
  }
}
